import Vue from 'vue';
import Gift from '@/tools/models/Gift';
import ApiRequest from '@/tools/ApiRequest';
import RequestException from '@/tools/helpers/RequestException';

export default Vue.extend({
  name: 'MyGifts',
  data: () => ({
    gifts: [] as Gift[],
    possibleGifts: [
      {
        id: 1,
        src: require('@/assets/img/faca.png'),
      },
      {
        id: 2,
        src: require('@/assets/img/parafusadeira.png'),
      },
      {
        id: 3,
        src: require('@/assets/img/gasolina.png'),
      },
      {
        id: 4,
        src: require('@/assets/img/maleta.png'),
      },
      {
        id: 5,
        src: require('@/assets/img/cortador.png'),
      },
    ],
  }),
  methods: {
    getGifts(): void {
      ApiRequest.myGifts()
        .then((response) => {
          this.gifts = response.data;
        })
        .catch((error) => new RequestException(error, this.$store, this.$router));
    },
    getGiftImage(id: number): string {
      let gift = this.possibleGifts.find((el) => el.id === id);

      return gift ? gift.src : undefined;
    },
  },
  created(): void {
    this.getGifts();
  },
});
